import React from 'react';
import {
  MessageSquareIcon,
  FileTextIcon,
  CalendarIcon,
  DollarSignIcon,
  ShieldIcon,
  SmartphoneIcon } from
'lucide-react';
export function Features() {
  const featureCategories = [
  {
    title: 'Communication',
    icon: MessageSquareIcon,
    mainFeature: 'Digital Communication Hub',
    description:
    'Bring all your community communication into one simple, organized space. Replace endless email chains and scattered WhatsApp groups with a central hub for community interaction.',
    subFeatures: [
    'Notice board & announcements – always visible',
    'Community chat – connect with ease',
    'Searchable message history',
    'Instant notifications']

  },
  {
    title: 'Governance',
    icon: CalendarIcon,
    mainFeature: 'Smart Meeting Management',
    description:
    'Take the hassle out of meetings with seamless digital tools.  Schedule meetings, send automatic invites, track RSVPs, and manage proxy voting digitally.',
    subFeatures: ['Digital RSVPs', 'Proxy management', 'Automated meeting reminders']
  },
  {
    title: 'Finance',
    icon: DollarSignIcon,
    mainFeature: 'Financial Transparency',
    description:
    'Keep your community’s finances transparent and easy to manage with built-in workflows and reporting tools.',
    subFeatures: [
    'Bill approval workflow',
    'Levy tracking',
    'Financial reports',
    'Full audit trail']

  },
  {
    title: 'Documents',
    icon: FileTextIcon,
    mainFeature: 'Document Library',
    description:
    'Keep every important document organized, secure, and always within reach. From bylaws to contracts, everything lives in one central hub',
    subFeatures: ['Secure cloud storage', 'Version control', 'Easy search']
  },
  {
    title: 'Security & Access Control',
    icon: ShieldIcon,
    mainFeature: 'Role-Based Permissions',
    description:
    'Protect your community’s information with clear, customizable access levels. Each person sees exactly what they need.',
    subFeatures: [
    'Secure access control',
    'Create sub-accounts for shared access',
    'Role-based permissions for Chairman, Treasurer, Admin, and more']

  },
  {
    title: 'Accessibility',
    icon: SmartphoneIcon,
    mainFeature: 'Mobile First Design',
    description:
    'Stay connected and in control wherever you are. Our platform is designed to work flawlessly across devices.',
    subFeatures: [
    'Works on any device',
    'Touch-friendly interface',
    'Offline notifications']

  }];

  return (
    <div id="features" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
            Features
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Everything You Need to Manage Your Strata
          </p>
          <p className="mt-4 max-w-3xl mx-auto text-xl text-gray-500">
            Comprehensive digital platform that covers all aspects of strata
            management, from daily communication to annual financial reporting.
          </p>
        </div>
        <div className="mt-16">
          <div className="grid grid-cols-1 gap-y-12 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
            {featureCategories.map((category) =>
            <div
              key={category.title}
              className="bg-white p-8 rounded-lg shadow-sm">

                <div className="flex items-center mb-4">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                    <category.icon className="h-6 w-6" aria-hidden="true" />
                  </div>
                  <h3 className="ml-4 text-xl font-bold text-gray-900">
                    {category.title}
                  </h3>
                </div>
                <h4 className="text-lg font-semibold text-blue-600 mb-2">
                  {category.mainFeature}
                </h4>
                <p className="text-base text-gray-500 mb-6">
                  {category.description}
                </p>
                <ul className="space-y-3">
                  {category.subFeatures.map((feature, index) =>
                <li key={index} className="flex items-start">
                      <div className="flex-shrink-0 mt-1">
                        <div className="h-5 w-5 rounded-full bg-blue-100 flex items-center justify-center">
                          <div className="h-2 w-2 rounded-full bg-blue-600"></div>
                        </div>
                      </div>
                      <p className="ml-3 text-base text-gray-700">{feature}</p>
                    </li>
                )}
                </ul>
                {category.footer &&
              <p className="text-base text-gray-500 mt-6">
                    {category.footer}
                  </p>
              }
              </div>
            )}
          </div>
        </div>
      </div>
    </div>);

}